import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { type ApplicationConfig, isDevMode, provideZoneChangeDetection } from "@angular/core";
// Decprecated since Angular 20, but still needed for PrimeNG components
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";

import { includeBearerTokenInterceptor } from "keycloak-angular";
import { MessageService } from "primeng/api";

import { routes } from "@/app/app.routes";
import { provideI18n } from "@/app/i18n.config";
import { provideKeycloakAngular } from "@/app/keycloak.config";
import { DRAWER_LINKS, LINKS } from "./shared/constants";
import { provideTheme } from "./theme.config";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
    provideKeycloakAngular(),
    provideI18n(),
    provideAnimationsAsync(),
    provideTheme(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    MessageService, // Used for Toast messages
    { provide: DRAWER_LINKS, useValue: LINKS },
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:30000",
    }),
  ],
};
